import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Container } from "semantic-ui-react";
import ReportHeader from "./../../../../components/ReportHeader";
import SRHCopyright from "./../../../../components/SRHCopyright";
import Printable from "./../../../../components/Printable";
import OverviewTable from "./components/OverviewTable";
import FiltersFooter from "../FiltersFooter";

class DomainScores extends Component {
  render() {
    const { totalRespondents, datasetName, workSettingsSurveyed, survey } = this.props.summaryReport;
    const { domainScores, unit, ready, sharedSummaryReport, page, benchmarkFootnote, landscape, configuration } = this.props;

    let surveyTitle = survey;
    if (survey === 'SELECT_2020') surveyTitle = 'SCORE';
    if (survey === 'VALLEY_2020') surveyTitle = 'SCOR';
    if (survey === 'SHA_2020') surveyTitle = 'SCORE';
    if (configuration && configuration.survey_title) surveyTitle = configuration.survey_title;

    let reportHeaderTitle = `Percent Positive Respondents by ${surveyTitle} Domain`;
    if (!/SOPS/.test(survey)) reportHeaderTitle += '*';

    if (ready) {
      return (
        <Printable page={page} landscape={landscape}>
          <ReportHeader
            title={reportHeaderTitle}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            summaryReport={this.props.summaryReport}
            smallerHeader={survey === "MAGNET"}
          />
          <OverviewTable
            domainScores={domainScores}
            survey={survey}
            sharedSummaryReport={sharedSummaryReport}
            summaryReport={this.props.summaryReport}
            benchmarkFootnote={benchmarkFootnote}
            configuration={configuration}
            landscape={landscape}
          />
          <FiltersFooter />
          <SRHCopyright textClass="large-font" />
        </Printable>
      );
    } else {
      return <Printable />;
    }
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    domainScores: store.domainScores.domainScores,
  };
})(DomainScores);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/DomainScores/index.jsx